import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Button } from '@/components/ui/button';

export function NotFoundPage() {
  return (
    <>
      <Helmet>
        <title>Page not found - CriticalBridge.AI</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <div className="container mx-auto flex min-h-[60vh] flex-col items-center justify-center px-4 py-20 text-center">
        <span className="font-mono text-sm uppercase tracking-widest text-muted-foreground">
          404
        </span>
        <h1 className="mt-4 text-3xl font-bold tracking-tight sm:text-4xl">
          We couldn&apos;t find that page.
        </h1>
        <p className="mt-4 max-w-md text-muted-foreground">
          The page you're looking for doesn't exist, or hasn't been built yet as we finish the
          site redesign.
        </p>
        <Button asChild className="mt-8">
          <Link to="/">Back to home</Link>
        </Button>
      </div>
    </>
  );
}
